import { useState } from 'react';

import './styles.css';

import EmojiiStronglyDisagree from './images/emoji-strongly-disagree.svg';
import EmojiiDisagree from './images/emoji-disagree.svg';
import EmojiiNeutral from './images/emoji-neutral.svg';
import EmojiiAgree from './images/emoji-agree.svg';
import EmojiiStronglyAgree from './images/emoji-strongly-agree.svg';

const rateGameOptions = [
  {
    name: 'Strongly Disagree',
    image: EmojiiStronglyDisagree
  },
  {
    name: 'Disagree',
    image: EmojiiDisagree
  },
  {
    name: 'Neutral',
    image: EmojiiNeutral
  },
  {
    name: 'Agree',
    image: EmojiiAgree
  },
  {
    name: 'Strongly Agree',
    image: EmojiiStronglyAgree
  }
]

export default function FeedbackForm({onSubmit}) {
  const [rateGameSelected, setRateGameSelected] = useState();
  const handleGameRateClick = (rate) => {
    setRateGameSelected(rate);
  }

  const [whatYouLike, setWhatYouLike] = useState('');
  const [whatYouDontLike, setWhatYouDontLike] = useState('');

  const handleWhatYouLikeChange = (event) => {
    setWhatYouLike(event.target.value);
  }

  const handleWhatYouDontLikeChange = (event) => {
    setWhatYouDontLike(event.target.value);
  }

  const [isLoading, setIsLoading] = useState(false);
  const [warningMessageRate, setWarningMessageRate] = useState('');
  const [warningMessageWhatYouLike, setWarningMessageWhatYouLike] = useState('');
  const [warningMessageWhatYouDontLike, setWarningMessageWhatYouDontLike] = useState('');

  const handleSubmitFeedback = () => {
    const whatYouLikeWaring = whatYouLike.length < 10 || whatYouLike.length > 200;
    const whatYouDontLikeWaring = whatYouDontLike.length < 10 || whatYouDontLike.length > 200;
    if (!rateGameSelected || whatYouLikeWaring || whatYouDontLikeWaring) {
      if(!rateGameSelected) {
        setWarningMessageRate('Please make your choice.');
      } else {
        setWarningMessageRate('');
      }
      if(whatYouLikeWaring) {
        setWarningMessageWhatYouLike('Please ensure your feedback is between 10 and 200 characters.');
      } else {
        setWarningMessageWhatYouLike('');
      }
      if(whatYouDontLikeWaring) {
        setWarningMessageWhatYouDontLike('Please ensure your feedback is between 10 and 200 characters.');
      } else {
        setWarningMessageWhatYouDontLike('');
      }
      return;
    }

    setIsLoading(true);
    onSubmit({
      rateGame: rateGameSelected,
      whatYouLike: whatYouLike,
      whatYouDontLike: whatYouDontLike
    });
  };

  return (
    <div className="level-feedbacks">
      <h2>That’s all for now!✨</h2>
      <div className="feedback-row">
        <label> 1. Would you recommend the exercise for this class?</label>
        <div className="rate-game-input-container">
          {
            rateGameOptions.map((rateGameOption, index) => (
              <button 
                key={index} 
                onClick={() => handleGameRateClick(rateGameOption.name)}
                className={`${rateGameOption.name === rateGameSelected ? 'selected' : ''}`}
              >
                <img src={rateGameOption.image} alt={`Emojii ${rateGameOption.name}`} />
                {rateGameOption.name}
              </button>
            ))
          }
        </div>
        <div className="warning">{warningMessageRate}</div>
      </div>
      <div className="feedback-row">
        <label htmlFor="what-you-like">2. What did you like about the exercise?</label>
        <textarea
          rows="4"
          id="what-you-like"
          placeholder="Type your thoughts here..."
          value={whatYouLike}
          onChange={handleWhatYouLikeChange}
        />
        <div className="warning">{warningMessageWhatYouLike}</div>
      </div>
      <div className="feedback-row">
        <label htmlFor="what-you-dont-like">3.What could have made the exercise more helpful for you?</label>
        <textarea
          rows="4"
          id="what-you-dont-like"
          placeholder="Type your thoughts here..."
          value={whatYouDontLike}
          onChange={handleWhatYouDontLikeChange}
        />
        <div className="warning">{warningMessageWhatYouDontLike}</div>
      </div>
      <button
        type="submit"
        onClick={handleSubmitFeedback}
        className={`button-navi button-submit ${isLoading ? 'loading' : ''}`}
      >
        {!isLoading && 'Submit'}
      </button>
    </div>
  );
}
